import React from "react";
import "./Coin.css";

const Coin = ({
  name,
  price,
  symbol,
  marketcap,
  volume,
  image,
  priceChange,
  
}) => {
  return (

    <>
    
      <div className="coin-container">
        <div className="coin-row">
          <div className="coin-img">
            {/* <h3>image</h3> */}
            <img src={image} alt="crypto" />
          </div>
          <div className="coin-symbol">
            <h3>Symbol</h3>
            <p className="coin-symbol">{symbol}</p>
          </div>
          <div className="coin-name">
            <h3>Name</h3>
            <h1>{name}</h1>
          </div>
          <div className="coin-price">
            <h3>Price</h3>
    



        <p className="coin-price">${price}</p>
          </div>
          <div className="coin-volume">
            <h3>Market cap</h3>
            <p className="coin-volume">${volume.toLocaleString()}</p>
          </div>
          <div className="coin-change-price">
            <h3>24h</h3>
            {priceChange < 0 ? (
              <p className="coin-percent red">{priceChange.toFixed(2)}%</p>
            ) : (
              <p className="coin-percent green">{priceChange.toFixed(2)}%</p>
            )}
          </div>
          <div className="coin-marketcap">
              <h3>24h Volume</h3>
            <p className="coin-marketcap">
              Mkt Cap: ${marketcap.toLocaleString()}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Coin;